import createIcon from '../../createIcon';

/**
 * @component @name Chair
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAxMVYxM0gxN1YxMUMxNyA5LjE0IDE4LjI4IDcuNTkgMjAgNy4xNFY2QzIwIDQuMzUgMTguNjUgMyAxNyAzSDdDNS4zNSAzIDQgNC4zNSA0IDZWNy4xNEM1LjcyIDcuNTkgNyA5LjE0IDcgMTFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjEgOUMxOS45IDkgMTkgOS45IDE5IDExVjE1SDVWMTFDNSA5LjkgNC4xIDkgMyA5QzEuOSA5IDEgOS45IDEgMTFWMTZDMSAxNy42NSAyLjM1IDE5IDQgMTlWMjBDNCAyMC41NSA0LjQ1IDIxIDUgMjFDNS41NSAyMSA2IDIwLjU1IDYgMjBWMTlIMThWMjBDMTggMjAuNTUgMTguNDUgMjEgMTkgMjFDMTkuNTUgMjEgMjAgMjAuNTUgMjAgMjBWMTlDMjEuNjUgMTkgMjMgMTcuNjUgMjMgMTZWMTFDMjMgOS45IDIyLjEgOSAyMSA5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Chair = createIcon('Chair', [
  [
    'path',
    {
      d: 'M7 11V13H17V11C17 9.14 18.28 7.59 20 7.14V6C20 4.35 18.65 3 17 3H7C5.35 3 4 4.35 4 6V7.14C5.72 7.59 7 9.14 7 11Z',
      key: '1yhxac',
    },
  ],
  [
    'path',
    {
      d: 'M21 9C19.9 9 19 9.9 19 11V15H5V11C5 9.9 4.1 9 3 9C1.9 9 1 9.9 1 11V16C1 17.65 2.35 19 4 19V20C4 20.55 4.45 21 5 21C5.55 21 6 20.55 6 20V19H18V20C18 20.55 18.45 21 19 21C19.55 21 20 20.55 20 20V19C21.65 19 23 17.65 23 16V11C23 9.9 22.1 9 21 9Z',
      key: 'y4gnlt',
    },
  ],
]);

export default Chair;
